import * as types from '../actions';

export default function(state = [], action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.SERVER_TIME_LIST_SUCCESS:
            if(response.status===200){
                return {
                    serverTimeList: response.data,
                    serverTimeListStatus: response.status,  
                    serverTimeListActivity:types.SERVER_TIME_LIST_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    serverTimeListStatus: (response.status)?response.status:0,  
                    serverTimeListActivity:types.SERVER_TIME_LIST_ERROR, 
                    serverTimeListErrorData:(response.data)?response.data:[]                             
                };
            }
        
        case types.SERVER_TIME_LIST_ERROR:
            return {
                serverTimeListStatus: (response && response.status)?response.status:0,
                serverTimeListActivity:types.SERVER_TIME_LIST_ERROR, 
                serverTimeListErrorData:(response && response.data)?response.data:[]                      
            };
        
        default:
            return state;
    
        }
    }